import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import {
  ActiveNoticeBannersDocument,
  type ActiveNoticeBannersQuery,
  type ActiveNoticeBannersQueryVariables,
} from '../../__codegen__/api'

const PARTNER_RE = /^\/partners\/([^/]+)(?:\/warehouses\/([^/]+))?/

export const parseIdsFromPath = (
  pathname: string
): { partnerId: string | null; warehouseId: string | null } => {
  const match = pathname.match(PARTNER_RE)
  if (!match) return { partnerId: null, warehouseId: null }
  return { partnerId: match[1] ?? null, warehouseId: match[2] ?? null }
}

export const toInt = (s: string | null): number | null => {
  if (s === null) return null
  const n = Number(s)
  return Number.isFinite(n) ? n : null
}

type ActiveNoticeBanner = ActiveNoticeBannersQuery['activeNoticeBanners'][number]

export const useActiveNoticeBanners = (): ActiveNoticeBanner[] => {
  const { pathname } = useLocation()
  const { partnerId, warehouseId } = useMemo(() => {
    const parsed = parseIdsFromPath(pathname)
    return {
      partnerId: toInt(parsed.partnerId),
      warehouseId: toInt(parsed.warehouseId),
    }
  }, [pathname])
  const { data } = useQuery<ActiveNoticeBannersQuery, ActiveNoticeBannersQueryVariables>(
    ActiveNoticeBannersDocument,
    {
      variables: {
        path: pathname,
        partnerId: partnerId ?? undefined,
        warehouseId: warehouseId ?? undefined,
      },
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'ignore',
    }
  )
  return data?.activeNoticeBanners ?? []
}
